<script>
import {mapGetters} from 'vuex';
import DeclarationItem from '../components/DeclarationItem.vue';
import NoCloud from '../assets/NoCloud.vue';
import Cloud from '../assets/Cloud.vue';

export default {
   name: 'CloudDeclarations',
   components: {Cloud, NoCloud, DeclarationItem},
   data() {
      return {
         stateSelection: null,
      };
   },
   computed: {
      ...mapGetters({
         isSME: 'isSME',
         studyPeriodMap: 'companies/studyPeriodMap',
         supportedPeriodIds: 'cloud/supportedPeriodIds',
         completed: 'cloud/isCompleted',
         declaration: 'cloud/declaration',
         importedVendors: 'cloud/importedVendors',
         manualVendors: 'cloud/manualVendors',
      }),

      periodNames() {
         return this.supportedPeriodIds
            .map((id) => this.studyPeriodMap[id]?.label)
            .filter((label) => !!label);
      },

      prettyPeriodNames() {
         const formatter = new Intl.ListFormat('en', {
            style: 'long',
            type: 'disjunction',
         });
         return formatter.format(this.periodNames);
      },

      hasVendors() {
         return this.importedVendors.length > 0 || this.manualVendors.length > 0;
      },

      isDisabled() {
         return this.isSME || this.completed || this.hasVendors;
      },
   },
   methods: {
      async declareCloud(declaration) {
         await this.$store.dispatch('cloud/saveDeclaration', {
            companyId: this.$companyId,
            declaration,
         });
      },
   },
};
</script>

<template>
   <div>
      <h5 id="label-study-years" class="mb-3" style="color: black; font-size: 16px">
         Did any of these projects require any qualified cloud computing in the time period{{
            periodNames.length === 1 ? '' : 's'
         }}
         {{ prettyPeriodNames }}?
      </h5>
      <div class="declaration-container">
         <DeclarationItem
            :active="declaration === false"
            :disabled="isDisabled"
            @input-declared="declareCloud"
            expense-type="cloud"
         >
            <template v-slot:icon>
               <NoCloud />
            </template>
            <template v-slot:description>
               <b>No, none</b> of these projects used cloud computing resources.
            </template>
         </DeclarationItem>
         <DeclarationItem
            :active="declaration === true"
            :disabled="isDisabled"
            :value="true"
            @input-declared="declareCloud"
            expense-type="cloud"
         >
            <template v-slot:icon>
               <Cloud />
            </template>
            <template v-slot:description>
               <b>Yes</b>, some of these projects used cloud computing resources.
            </template>
         </DeclarationItem>
      </div>
   </div>
</template>

<style scoped lang="scss">
.declaration-container {
   display: flex;
   flex-wrap: wrap;
   gap: 1rem;
   margin-bottom: 2rem;
}
</style>
